import {
  CircleCompletedSvg,
  EmailActiveSvg,
  EmailSvg,
  PhoneSvg,
} from "@/components/svg"

enum enumsCertification {
  allCertification = "ALLCERTIFICATION",
  emailCertification = "EMAILCERTIFICATION",
  phoneCertification = "PHONECERTIFICATION",
  otpCheck = "OTPCHECK",
  result = "RESULT",
}

const trackingByCertification = {
  [enumsCertification.allCertification]: "verifica-contatti",
  [enumsCertification.phoneCertification]: "verifica-numero",
  [enumsCertification.emailCertification]: "verifica-mail",
}

const verificationState = {
  "0_1": enumsCertification.allCertification,
  "1_0": enumsCertification.allCertification,
  "1_1": enumsCertification.allCertification,

  "0_2": enumsCertification.emailCertification,
  "1_2": enumsCertification.emailCertification,

  "2_0": enumsCertification.phoneCertification,
  "2_1": enumsCertification.phoneCertification,
  "2_2": enumsCertification.phoneCertification,
} as const

const verificationStateLabels = {
  "1_1": enumsCertification.allCertification,

  "0_1": enumsCertification.emailCertification,
  "0_2": enumsCertification.emailCertification,
  "1_2": enumsCertification.emailCertification,

  "1_0": enumsCertification.phoneCertification,
  "2_0": enumsCertification.phoneCertification,
  "2_1": enumsCertification.phoneCertification,
  "2_2": enumsCertification.phoneCertification,
} as const

type verificationStateType = keyof typeof verificationState

type TypeCertification =
  | enumsCertification.allCertification
  | enumsCertification.emailCertification
  | enumsCertification.phoneCertification

const configTextDefault = {
  [enumsCertification.allCertification]: {
    headerTitle: "PostLoginDialog.DefaultCertification.bothHeader",
    headerTitlePhone: "PostLoginDialog.DefaultCertification.bothHeader",
    headerTitleEmail: "PostLoginDialog.DefaultCertification.bothHeader",
    text: "PostLoginDialog.DefaultCertification.bothText",
  },
  [enumsCertification.phoneCertification]: {
    headerTitle: "PostLoginDialog.PhoneCertification.genericHeader",
    headerTitlePhone: "PostLoginDialog.PhoneCertification.header",
    headerTitleEmail: "PostLoginDialog.PhoneCertification.emailHeader",
    text: "PostLoginDialog.PhoneCertification.step0",
  },
  [enumsCertification.emailCertification]: {
    headerTitle: "PostLoginDialog.EmailCertification.header",
    headerTitlePhone: "PostLoginDialog.EmailCertification.header",
    headerTitleEmail: "PostLoginDialog.EmailCertification.header",
    text: "PostLoginDialog.EmailCertification.text",
  },
} as const

const configTextOtp = {
  [enumsCertification.allCertification]: {
    headerTitleOtp: "PostLoginDialog.OtpVerification.phoneCertificationHeader",
    textOtp: "PostLoginDialog.OtpVerification.phoneCertificationText",
  },
  [enumsCertification.phoneCertification]: {
    headerTitleOtp: "PostLoginDialog.OtpVerification.phoneCertificationHeader",
    textOtp: "PostLoginDialog.OtpVerification.phoneCertificationText",
  },
  [enumsCertification.emailCertification]: {
    headerTitleOtp: "PostLoginDialog.OtpVerification.emailCertificationHeader",
    textOtp: "PostLoginDialog.OtpVerification.emailCertificationText",
  },
} as const

const postLoginStepper = {
  [enumsCertification.phoneCertification]: {
    icon: PhoneSvg,
    activeIcon: PhoneSvg,
    completedIcon: CircleCompletedSvg,
  },
  [enumsCertification.emailCertification]: {
    icon: EmailSvg,
    activeIcon: EmailActiveSvg,
    completedIcon: CircleCompletedSvg,
  },
}

type KeyStep = enumsCertification

const certificationStep = "certificationStep"
const otpVerification = "otpVerification"
const certificationStatus = "certificationStatus"
const verifyContacts = "verifyContacts"
const otpRefreshed = "otpRefreshed"

const cleanupParams = [
  certificationStep,
  otpVerification,
  certificationStatus,
  verifyContacts,
  otpRefreshed,
]

export {
  certificationStatus,
  certificationStep,
  cleanupParams,
  configTextDefault,
  configTextOtp,
  enumsCertification,
  otpRefreshed,
  otpVerification,
  postLoginStepper,
  trackingByCertification,
  verificationState,
  verificationStateLabels,
  verifyContacts,
}
export type { KeyStep, TypeCertification, verificationStateType }
